import React, {useState} from "react";
import Icon from "../../system/components/icon";
import WorkspaceMediaThumbnail from "../../system/components/workspace-media-thumbnail";
import {downloadWorkspaceMedia} from "../../system/private-media";
import {getFileSize} from "../../system/utils";
import {useTranslate} from "../../system/useTranslate";

function ChatMessageAttachment({file, workspaceId, ownMessage = false, compact = false, onError}) {
    const translate = useTranslate();
    const [downloading, setDownloading] = useState(false);
    const imageFile = String(file?.mime || "").startsWith("image/") || Boolean(file?.formats);

    const download = async () => {
        if (downloading) return;
        setDownloading(true);
        try {
            await downloadWorkspaceMedia(file, workspaceId);
        } catch (error) {
            onError?.(error);
        } finally {
            setDownloading(false);
        }
    };

    if (compact) {
        return (
            <WorkspaceMediaThumbnail
                file={file}
                workspaceId={workspaceId}
                width="2rem"
                onError={onError}
            />
        );
    }

    const fileSize = getFileSize(Number(file?.size || 0) * 1000);
    return (
        <div
            className={`p-2 border-1 border-round flex align-items-center justify-content-start gap-2 w-full ${ownMessage ? "bg-primary-200 border-primary" : "surface-300 border-400"}`}
        >
            <WorkspaceMediaThumbnail
                file={file}
                workspaceId={workspaceId}
                width={imageFile ? "10rem" : "2.5rem"}
                preview={imageFile}
                onError={onError}
            />
            <div className="flex flex-column gap-1 text-xs min-w-0 flex-1">
                <span className="white-space-nowrap font-bold text-overflow-ellipsis overflow-hidden w-full">
                    {file?.name}
                </span>
                <span className="text-400">
                    {`${fileSize.size} ${translate(fileSize.unit)}`}
                </span>
            </div>
            <Icon
                icon={downloading ? "mi mi:progress_activity" : "mi mi:download"}
                className={`w-2rem h-2rem flex align-items-center justify-content-center text-lg text-primary ${downloading ? "pi-spin" : ""}`}
                ariaLabel={`${translate("inbox.attachment.download")} ${file?.name || ""}`.trim()}
                disabled={downloading}
                onClick={download}
            />
        </div>
    );
}

export default ChatMessageAttachment;
